import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import Cookie from 'utils/cookies';
import { loginEventEmitter } from 'components/Login/Login';
import {
  checkIframeUserLogin,
  initializeIframeMessageListener,
  initiateIframeLogin,
} from 'routes/games/layouts/utils';
import {
  loadSyncUp,
  loadStreakData,
  loadPreviousPuzzleData,
  loadGameStatusData,
} from '../../../redux';
//import NewGameTimer from '../NewGameTimer/NewGameTimer';
import CongratulationsCardSlider from '../CongratulationsCardSlider/CongratulationsCardSlider';
import NewStreakCard from '../NewStreakCard/NewStreakCard';
import PreviousPuzzleCard from '../PreviousPuzzleCard/PreviousPuzzleCard';
import s from './CongratulationsNew.scss';
import GameOverlay from '../GameOverlay/GameOverlay';

const CongratulationsNew = props => {
  const {
    gamejsonUrl,
    gameId,
    resultData,
    playAgainCheck,
    showCongrate,
    type,
    subType,
    isMobile,
    isGameIframe,
    iframeSource,
    iframeLang,
    previousPuzzleData,
    gameStatusData,
    userData,
    gamesconfigData,
    buttonClicked,
  } = props;

  const [showOverlay, setShowOverlay] = useState(false);
  const [APIError, setAPIError] = useState(false);
  const [showLoader, setLoader] = useState(true);
  const [retryKey, setRetryKey] = useState(0);
  const [hasSynced, setHasSynced] = useState(false);
  const userDataRef = useRef(userData);
  const [isIframeLoggedIn, setIsIframeLoggedIn] = useState(false);

  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  const getData = (tempGrxId, tempSsoId) => {
    // loadStreakData only for logged-in users
    if (
      typeof props.loadStreakData === 'function' &&
      (userData?.isLoggedIn || (isGameIframe && isIframeLoggedIn))
    ) {
      props.loadStreakData({
        gameId,
        gameType: type,
        grxId: tempGrxId || grxId,
        ssoId: tempSsoId || ssoId,
      });
    }
    // loadPreviousPuzzleData for all users (logged-in and non-logged-in)
    if (typeof props.loadPreviousPuzzleData === 'function') {
      props.loadPreviousPuzzleData({
        gameType: type,
        grxId: tempGrxId || grxId,
        ssoId: tempSsoId || ssoId,
      });
    }
    // loadGameStatusData for all logged-in users
    if (
      typeof props.loadGameStatusData === 'function' &&
      ((userData?.isLoggedIn || (isGameIframe && isIframeLoggedIn)) &&
        (resultData?.loggedInResult === undefined ||
          resultData?.loggedInResult === false))
    ) {
      props.loadGameStatusData({
        gameId,
        gameType: type,
        grxId: tempGrxId || grxId,
        ssoId: tempSsoId || ssoId,
      });
    }
  };

  const handleOverlayClose = () => {
    setShowOverlay(false);
  };

  const openLoginBox = () => {
    const ga4EventTypeValue = 'streak_game';

    if (isGameIframe && iframeSource) {
      // Set up message handler with callbacks
      const cleanup = initializeIframeMessageListener({
        onLoginSuccess: data => {
          if (data && data.userData && data.userData.userDetails) {
            // Update grxId and ssoId with iframe data if available
            const tempGrxId = data?.userData?.grxId || grxId;
            const tempSsoId = data?.userData?.userDetails?.ssoid || ssoId;
            if (data?.userData?.userDetails?.ssoid) {
              setIsIframeLoggedIn(true);
            }
            userDataRef.current = {
              ...userDataRef.current,
              isLoggedIn: true,
              getFirstName:
                data.userData.userDetails.FL_N ||
                data.userData.userDetails.loginId ||
                '',
              getIcon: data.userData.userDetails.profileImageUrl || '',
            };
            if (data?.userData?.userDetails?.ssoid) {
              const params = {
                userName:
                  data.userData.userDetails.FL_N ||
                  data.userData.userDetails.loginId ||
                  'N/A',
                userImage: data.userData.userDetails.profileImageUrl || '',
                grxId: tempGrxId,
                ssoId: tempSsoId,
              };
              props.loadSyncUp(params);
            }
            setHasSynced(true);
            setTimeout(() => {
              getData(tempGrxId, tempSsoId);
            }, 2000);
          } else {
            console.log(`Could not login`);
          }
        },
      });
      // Initiate login
      initiateIframeLogin(iframeSource, iframeLang);
      // Clean up listener when component unmounts
      return cleanup;
    }
    return loginEventEmitter(undefined, {}, undefined, ga4EventTypeValue);
  };

  const gameSyncCall = () => {
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    const params = {
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData && userData.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
          setTimeout(() => {
            getData();
          }, 2000);
        }
        if (userData && !userData.isLoggedIn) {
          getData();
          setHasSynced(false);
        }
      }
    },
    [userData, hasSynced, props.loadSyncUp],
  );

  useEffect(
    () => {
      if (gameStatusData && !gameStatusData.error) {
        setAPIError(false);
        setLoader(false);
      } else if (gameStatusData && gameStatusData.error) {
        setAPIError(true);
        setLoader(false);
      }
    },
    [gameStatusData],
  );

  const retryClicked = () => {
    setRetryKey(prevKey => prevKey + 1);
    setLoader(true);
    getData();
  };

  // useEffect(() => {
  //   getData();
  // }, []);

  useEffect(
    () => {
      if (isGameIframe && iframeSource) {
        const cleanup = initializeIframeMessageListener({
          onLoginStatus: data => {
            if (data && data.userData && data.userData.userDetails) {
              // Update grxId and ssoId with iframe data if available
              const tempGrxId = data?.userData?.grxId || grxId;
              const tempSsoId = data?.userData?.userDetails?.ssoid || ssoId;
              if (data?.userData?.userDetails?.ssoid) {
                setIsIframeLoggedIn(true);
              }
              userDataRef.current = {
                ...userDataRef.current,
                isLoggedIn: true,
                getFirstName:
                  data.userData.userDetails.FL_N ||
                  data.userData.userDetails.loginId ||
                  '',
                getIcon: data.userData.userDetails.profileImageUrl || '',
              };
              if (data?.userData?.userDetails?.ssoid) {
                const params = {
                  userName:
                    data.userData.userDetails.FL_N ||
                    data.userData.userDetails.loginId ||
                    'N/A',
                  userImage: data.userData.userDetails.profileImageUrl || '',
                  grxId: tempGrxId,
                  ssoId: tempSsoId,
                };
                props.loadSyncUp(params);
              }
              setHasSynced(true);
              setTimeout(() => {
                getData(tempGrxId, tempSsoId);
              }, 2000);
            } else {
              console.log(`Could not login`);
            }
            cleanup(); // Clean up listener after receiving data
          },
        });
        // Check login status
        checkIframeUserLogin(iframeSource, iframeLang);
        return cleanup;
      }
      return undefined;
    },
    [isGameIframe, iframeSource, iframeLang],
  );

  const isUserLoggedIn =
    (userData && userData.isLoggedIn) || (isGameIframe && isIframeLoggedIn);

  useEffect(
    () => {
      if (showCongrate) {
        const gaData = {
          event: 'user_shown_games',
          type: 'congratulations_screen',
          label:
            // eslint-disable-next-line no-nested-ternary
            typeof playAgainCheck === 'string'
              ? 'view_results'
              : playAgainCheck === false ? 'submit_game' : '',
          page_template: 'gameplay',
          section: 'games',
          subsection:
            type === 'loop-a-loop' ? 'loop_the_loop' : type?.replace(/-/g, '_'),
          browsing_platform: isMobile ? 'mweb' : 'web',
          game_id: gameId,
          level: subType || 'N/A',
          game_of_the_day: window.location.href
            .toLowerCase()
            .includes('/today'),
          login_status: !!ssoId,
          user_grx_id: grxId,
        };
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        analyticsWrapper('ga4', gaData);
        analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
      }
    },
    [showCongrate],
  );

  // Use gameStatusData if available, otherwise fall back to resultData
  const displayData =
    gameStatusData &&
    Object.keys(gameStatusData).length > 0 &&
    !gameStatusData.error
      ? gameStatusData
      : resultData;

  return (
    displayData && (
      <div
        className={`${s.pageWrapper} congratulationsNewPageWrapper`}
        key={retryKey}
      >
        <InViewObserver>
          {isUserLoggedIn &&
            APIError && (
              <div className={s.loginError}>
                <p>Something went wrong</p>
                <div className={s.btn}>
                  <button className={`${s.shadowBtn}`} onClick={retryClicked}>
                    Retry
                  </button>
                </div>
              </div>
            )}
          {isUserLoggedIn &&
            showLoader && (
              <div className="bgNone">
                <LoaderSpinner />
              </div>
            )}
          <CongratulationsCardSlider
            resultData={displayData}
            userData={userData}
            isMobile={isMobile}
            gameId={gameId}
            gameType={type}
            gameLevel={subType}
            buttonClicked={buttonClicked}
            loadSyncUp={props.loadSyncUp}
          />
          {/* Below Code is for Check Solution Button */}
          {displayData &&
            displayData.solutionData &&
            displayData.solutionData.showSolutionCta &&
            displayData.solutionData.showSolutionCta === true && (
              <div className={s.solutionCheckContainer}>
                <div className={s.solutionCheck}>
                  <button
                    type="button"
                    className={s.solutionCheckBtn}
                    onClick={() => {
                      setShowOverlay(true);
                      const gaData = {
                        event: 'user_click_games',
                        type: 'check_solution',
                        label: 'solution_popup',
                        page_template: 'gameplay',
                        section: 'games',
                        subsection:
                          type === 'loop-a-loop'
                            ? 'loop_the_loop'
                            : type?.replace(/-/g, '_'),
                        browsing_platform: isMobile ? 'mweb' : 'web',
                        game_id: gameId,
                        level: subType || 'N/A',
                        game_of_the_day: window.location.href
                          .toLowerCase()
                          .includes('/today'),
                        login_status: !!ssoId,
                        user_grx_id: grxId,
                      };
                      if (ssoId) {
                        gaData.sso_id = ssoId;
                      }
                      analyticsWrapper('ga4', gaData);
                    }}
                  >
                    {displayData.solutionData.title
                      ? displayData.solutionData.title
                      : 'Check Solution'}
                  </button>

                  {showOverlay && (
                    <GameOverlay
                      buttonClicked={buttonClicked}
                      popUpType="gamesolution"
                      gameId={gameId}
                      isMobile={isMobile}
                      gameType={type === 'loop-a-loop' ? 'loop_a_loop' : type}
                      gameOverlayCallback={handleOverlayClose}
                      gameLevel={subType}
                      gamejsonUrl={gamejsonUrl}
                    />
                  )}
                </div>
              </div>
            )}
          {displayData.streakData && (
            <NewStreakCard
              streakData={displayData.streakData}
              dateInfo={displayData.dateInfo}
              userData={userData}
              isMobile={isMobile}
              gameId={gameId}
              gameType={type}
              gameLevel={subType}
              isGameIframe={isGameIframe}
              iframeSource={iframeSource}
              iframeLang={iframeLang}
              isUserLoggedIn={isUserLoggedIn}
              openLoginBox={openLoginBox}
              loadSyncUp={props.loadSyncUp}
              gamesconfigData={gamesconfigData}
            />
          )}
          {previousPuzzleData && (
            <PreviousPuzzleCard
              loadSyncUp={props.loadSyncUp}
              previousPuzzleData={previousPuzzleData}
              isUserLoggedIn={isUserLoggedIn}
              isMobile={isMobile}
              gameId={gameId}
              gameType={type}
              gameLevel={subType}
              openLoginBox={openLoginBox}
            />
          )}
        </InViewObserver>
      </div>
    )
  );
};

CongratulationsNew.propTypes = {
  gameId: PropTypes.string,
  resultData: PropTypes.shape({}),
  showCongrate: PropTypes.bool,
  playAgainCheck: PropTypes.bool,
  type: PropTypes.string,
  subType: PropTypes.string,
  isMobile: PropTypes.bool,
  isGameIframe: PropTypes.bool,
  iframeSource: PropTypes.string,
  iframeLang: PropTypes.string,
  loadSyncUp: PropTypes.func,
  loadStreakData: PropTypes.func,
  loadPreviousPuzzleData: PropTypes.func,
  loadGameStatusData: PropTypes.func,
};

CongratulationsNew.defaultProps = {
  gameId: '',
  resultData: '',
  showCongrate: true,
  playAgainCheck: false,
  type: 'sudoku',
  subType: '',
  isMobile: false,
  isGameIframe: false,
  iframeSource: '',
  iframeLang: '',
  loadSyncUp: () => {},
  loadStreakData: () => {},
  loadPreviousPuzzleData: () => {},
  loadGameStatusData: () => {},
};

const mapStateToProps = state => ({
  gamesconfigData: _get(state, 'toigames.gamesconfig', ''),
  // previousPuzzleData: _get(state, 'toigames.previousPuzzle', {}),
  previousPuzzleData: state.toigames && state.toigames.previousPuzzle,
  gameStatusData: _get(state, 'toigames.gameStatus', {}),
  userData: state.login.userData,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  loadStreakData: params => {
    dispatch(loadStreakData(params));
  },
  loadPreviousPuzzleData: params => {
    dispatch(loadPreviousPuzzleData(params));
  },
  loadGameStatusData: params => {
    dispatch(loadGameStatusData(params));
  },
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CongratulationsNew);
